import { vs2ngaLimitedReleasesListConstants } from "../_redux-constants";

export function vs2ngaLimitedReleasesListReducer(
  state = {
    vs2ngaLimitedReleasesListLoading: false,
    vs2ngaLimitedReleasesListData: null,
    vs2ngaLimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        vs2ngaLimitedReleasesListLoading: true,
        vs2ngaLimitedReleasesListData: null,
        vs2ngaLimitedReleasesListError: null,
      });
    case vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaLimitedReleasesListLoading: false,
        vs2ngaLimitedReleasesListData: action.data,
      });
    case vs2ngaLimitedReleasesListConstants.VS2NGA_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2ngaLimitedReleasesListLoading: false,
        vs2ngaLimitedReleasesListData: null,
        vs2ngaLimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
